import { useState } from 'react';

export default function ShopInventory() {
  const [visibleProducts, setVisibleProducts] = useState(8);

  const categories = [
    {
      name: 'Brake Pads & Rotors',
      icon: 'ri-disc-line',
      description: 'Premium brake components for all makes and models',
      price: 'From $64.99',
      image:
        'https://public.readdy.ai/ai/img_res/becba9d22157a919525b8beb28aa9c4e.jpg',
    },
    {
      name: 'Wheel Bearings & Hubs',
      icon: 'ri-settings-4-line',
      description: 'Durable wheel bearings and hub assemblies',
      price: 'From $40.00',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20wheel%20bearing%20and%20hub%20assembly%20on%20white%20background%20professional%20product%20photography%20metal%20components%20catalog%20style%20clean%20lighting&width=400&height=300&seq=cat-bearings-001&orientation=landscape',
    },
    {
      name: 'Suspension & Steering',
      icon: 'ri-steering-2-line',
      description: 'Control arms, ball joints, tie rods and more',
      price: 'From $79.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20suspension%20control%20arm%20and%20steering%20components%20on%20white%20background%20professional%20product%20photography%20metal%20parts%20catalog%20style&width=400&height=300&seq=cat-suspension-001&orientation=landscape',
    },
    {
      name: 'Filters (Oil / Air / Cabin)',
      icon: 'ri-filter-3-line',
      description: 'Quality filters for engine protection and cabin comfort',
      price: 'From $12.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20oil%20filter%20air%20filter%20and%20cabin%20filter%20set%20on%20white%20background%20professional%20product%20photography%20clean%20catalog%20style%20organized%20layout&width=400&height=300&seq=cat-filters-001&orientation=landscape',
    },
    {
      name: 'Spark Plugs & Ignition',
      icon: 'ri-flashlight-fill',
      description: 'Reliable ignition components for optimal performance',
      price: 'From $8.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20spark%20plugs%20and%20ignition%20coils%20on%20white%20background%20professional%20product%20photography%20clean%20catalog%20style%20automotive%20parts&width=400&height=300&seq=cat-ignition-001&orientation=landscape',
    },
    {
      name: 'Batteries & Charging',
      icon: 'ri-battery-charge-line',
      description: 'Powerful batteries and charging system parts',
      price: 'From $199.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20car%20battery%20and%20alternator%20on%20white%20background%20professional%20product%20photography%20black%20battery%20with%20terminals%20catalog%20style&width=400&height=300&seq=cat-battery-001&orientation=landscape',
    },
    {
      name: 'Fluids & Coolant',
      icon: 'ri-drop-line',
      description: 'Premium automotive fluids and coolants',
      price: 'From $9.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20motor%20oil%20bottles%20and%20coolant%20containers%20on%20white%20background%20professional%20product%20photography%20clean%20catalog%20style%20organized%20display&width=400&height=300&seq=cat-fluids-001&orientation=landscape',
    },
    {
      name: 'Sensors & Electrical',
      icon: 'ri-cpu-line',
      description: 'Sensors, switches and electrical components',
      price: 'From $24.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20sensors%20and%20electrical%20components%20on%20white%20background%20professional%20product%20photography%20electronic%20parts%20catalog%20style%20clean%20lighting&width=400&height=300&seq=cat-sensors-001&orientation=landscape',
    },
    {
      name: 'Wipers & Lighting',
      icon: 'ri-lightbulb-line',
      description: 'Wiper blades, bulbs and lighting solutions',
      price: 'From $14.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20wiper%20blades%20and%20LED%20headlight%20bulbs%20on%20white%20background%20professional%20product%20photography%20clean%20catalog%20style%20modern%20car%20parts&width=400&height=300&seq=cat-wipers-001&orientation=landscape',
    },
    {
      name: 'Engine Mounts / Belts / Pulleys',
      icon: 'ri-settings-3-line',
      description: 'Engine mounts, serpentine belts and pulley systems',
      price: 'From $34.99',
      image:
        'https://readdy.ai/api/search-image?query=automotive%20engine%20mount%20serpentine%20belt%20and%20pulley%20on%20white%20background%20professional%20product%20photography%20rubber%20and%20metal%20parts%20catalog%20style&width=400&height=300&seq=cat-engine-001&orientation=landscape',
    },
  ];

  const featuredProducts = [
    {
      name: 'TOPCHOICE CERAMIC PADS',
      category: 'Brakes',
      fitment: 'Fits: 2016-2021 Honda Civic, 2017-2022 CR-V',
      regularPrice: 89.99,
      salePrice: 40.00,
      savings: 49.99,
      stock: 'In Stock',
      stockColor: 'bg-green-600',
      image:
        'https://readdy.ai/api/search-image?query=Wagner%20ThermoQuiet%20ceramic%20brake%20pads%20in%20retail%20packaging%20on%20white%20background%20professional%20automotive%20product%20photography%20clean%20studio%20lighting%20catalog%20style&width=350&height=350&seq=prod-brake-pads-001&orientation=squarish',
    },
    // ... (other products omitted for brevity – keep the original objects)
  ];

  /** Scroll the quote form into view */
  const scrollToQuote = () => {
    const quoteSection = document.getElementById('inventory-quote');
    if (quoteSection) {
      quoteSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  /** Load more products, never exceeding the array length */
  const loadMoreProducts = () => {
    setVisibleProducts((prev) => Math.min(prev + 8, featuredProducts.length));
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-black mb-4">
            Shop Our Inventory Highlights
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Weekly specials on premium auto parts. Updated regularly with the best deals in
            Mississauga.
          </p>
        </div>

        {/* Trust Bar */}
        <div className="bg-white rounded-2xl p-6 mb-12 shadow-lg">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-center">
            {/* ... trust items unchanged ... */}
          </div>
        </div>

        {/* Featured Categories */}
        <div className="mb-16">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {categories.map((category, index) => (
              <div
                key={index}
                onClick={scrollToQuote}
                className="group bg-white rounded-xl p-5 hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-100 hover:border-red-200"
              >
                <div className="relative mb-4 h-32 w-full rounded-lg overflow-hidden bg-gray-50">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg mb-3">
                  <i className={`${category.icon} text-red-600 text-xl`}></i>
                </div>
                <h4 className="font-rajdhani font-bold text-base text-black mb-2 leading-tight">
                  {category.name}
                </h4>
                <p className="text-gray-600 text-xs mb-2 leading-relaxed">{category.description}</p>
                <p className="font-rajdhani font-bold text-red-600 text-sm mb-3">{category.price}</p>
                <button className="text-red-600 font-rajdhani font-semibold text-sm hover:text-red-700 transition-colors whitespace-nowrap">
                  Ask Us <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Products */}
        <div className="mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-product-shop>
            {featuredProducts.slice(0, visibleProducts).map((product, index) => (
              <div
                key={index}
                className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
              >
                <div className="relative h-56 w-full bg-gray-50">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain p-4" />
                  <span
                    className={`absolute top-3 right-3 ${product.stockColor} text-white text-xs px-3 py-1 rounded-full font-semibold`}
                  >
                    {product.stock}
                  </span>
                  <span className="absolute top-3 left-3 bg-red-600 text-white text-xs px-3 py-1 rounded-full font-semibold">
                    Save ${product.savings.toFixed(2)}
                  </span>
                </div>

                <div className="p-5">
                  <span className="inline-block bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full font-medium mb-2">
                    {product.category}
                  </span>
                  <h4 className="font-rajdhani font-bold text-base text-black mb-2 leading-tight line-clamp-2">
                    {product.name}
                  </h4>
                  <p className="text-gray-600 text-xs mb-3 leading-relaxed line-clamp-2">{product.fitment}</p>

                  <div className="flex items-baseline gap-2 mb-4">
                    <span className="text-gray-400 text-sm line-through">
                      ${product.regularPrice.toFixed(2)}
                    </span>
                    <span className="font-rajdhani font-bold text-2xl text-red-600">
                      ${product.salePrice.toFixed(2)}
                    </span>
                  </div>

                  <div className="space-y-2">
                    <a
                      href="tel:905-226-0408"
                      className="flex items-center justify-center gap-2 w-full bg-red-600 hover:bg-red-700 text-white px-4 py-2.5 rounded-lg font-rajdhani font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-phone-fill"></i>
                      Call Now
                    </a>
                    <button
                      onClick={scrollToQuote}
                      className="flex items-center justify-center gap-2 w-full bg-gray-100 hover:bg-gray-200 text-black px-4 py-2.5 rounded-lg font-rajdhani font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-mail-line"></i>
                      Get Quote
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Fixed conditional rendering – the original JSX had an HTML‑entity typo */}
          {visibleProducts < featuredProducts.length && (
            <div className="text-center">
              <button
                onClick={loadMoreProducts}
                className="inline-flex items-center gap-2 bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full font-rajdhani font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Load More Products
                <i className="ri-arrow-down-line"></i>
              </button>
            </div>
          )}
        </div>

        {/* Quote Form */}
        <div id="inventory-quote">
          <QuoteFormInventory />
        </div>
      </div>
    </section>
  );
}

/* --------------------------------------------------------------
   Quote form component – isolated for clarity and error handling
   -------------------------------------------------------------- */
function QuoteFormInventory() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    year: '',
    make: '',
    model: '',
    vin: '',
    part: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Basic client‑side validation (optional but improves UX)
    if (!formData.name.trim() || !formData.phone.trim() || !formData.year.trim() || !formData.make.trim() || !formData.model.trim() || !formData.part.trim()) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/inventory-quote-na-discount', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          year: '',
          make: '',
          model: '',
          vin: '',
          part: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
      <div className="text-center mb-8">
        <h3 className="font-rajdhani font-bold text-3xl md:text-4xl text-black mb-3">
          Request a Quote
        </h3>
        <p className="text-gray-600 text-lg">Fast reply. Fitment verified. Best prices guaranteed.</p>
      </div>

      <form
        onSubmit={handleSubmit}
        data-readdy-form
        id="inventory-quote-form"
        className="max-w-3xl mx-auto"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Name */}
          <div>
            <label htmlFor="inv-name" className="block text-gray-700 font-semibold mb-2">
              Full Name *
            </label>
            <input
              type="text"
              id="inv-name"
              name="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
              placeholder="John Smith"
            />
          </div>

          {/* Phone */}
          <div>
            <label htmlFor="inv-phone" className="block text-gray-700 font-semibold mb-2">
              Phone Number *
            </label>
            <input
              type="tel"
              id="inv-phone"
              name="phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
              placeholder="905-226-0408"
            />
          </div>

          {/* Year */}
          <div>
            <label htmlFor="inv-year" className="block text-gray-700 font-semibold mb-2">
              Vehicle Year *
            </label>
            <input
              type="text"
              id="inv-year"
              name="year"
              value={formData.year}
              onChange={(e) => setFormData({ ...formData, year: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
              placeholder="2018"
            />
          </div>

          {/* Make */}
          <div>
            <label htmlFor="inv-make" className="block text-gray-700 font-semibold mb-2">
              Vehicle Make *
            </label>
            <input
              type="text"
              id="inv-make"
              name="make"
              value={formData.make}
              onChange={(e) => setFormData({ ...formData, make: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
              placeholder="Honda"
            />
          </div>

          {/* Model */}
          <div>
            <label htmlFor="inv-model" className="block text-gray-700 font-semibold mb-2">
              Vehicle Model *
            </label>
            <input
              type="text"
              id="inv-model"
              name="model"
              value={formData.model}
              onChange={(e) => setFormData({ ...formData, model: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
              placeholder="Civic"
            />
          </div>

          {/* VIN */}
          <div>
            <label htmlFor="inv-vin" className="block text-gray-700 font-semibold mb-2">
              VIN (Optional but Recommended)
            </label>
            <input
              type="text"
              id="inv-vin"
              name="vin"
              value={formData.vin}
              onChange={(e) => setFormData({ ...formData, vin: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
              placeholder="1HGBH41JXMN109186"
            />
          </div>
        </div>

        {/* Part Needed */}
        <div className="mb-6">
          <label htmlFor="inv-part" className="block text-gray-700 font-semibold mb-2">
            Part Needed *
          </label>
          <input
            type="text"
            id="inv-part"
            name="part"
            value={formData.part}
            onChange={(e) => setFormData({ ...formData, part: e.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm"
            placeholder="Front brake pads and rotors"
          />
        </div>

        {/* Additional Details */}
        <div className="mb-6">
          <label htmlFor="inv-message" className="block text-gray-700 font-semibold mb-2">
            Additional Details
          </label>
          <textarea
            id="inv-message"
            name="message"
            value={formData.message}
            onChange={(e) => {
              if (e.target.value.length <= 500) {
                setFormData({ ...formData, message: e.target.value });
              }
            }}
            rows={4}
            maxLength={500}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 text-sm resize-none"
            placeholder="Any additional information..."
          ></textarea>
          <div className="text-right text-sm text-gray-500 mt-1">
            {formData.message.length}/500 characters
          </div>
        </div>

        {/* Submit button */}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-400 text-white px-8 py-4 rounded-full font-rajdhani font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          {isSubmitting ? 'Submitting...' : 'Submit Quote Request'}
        </button>

        {/* Feedback messages */}
        {submitStatus === 'success' && (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-center">
            Thank you! We'll verify fitment and get back to you shortly.
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-center">
            Something went wrong. Please call us at 905-226-0408.
          </div>
        )}
      </form>
    </div>
  );
}
